<div [formGroup]="form" style="position: relative;">
    <input type="text" [minDate]="endMinDate" [maxDate]="maxDate" [formControlName]="field.name"
        class="form-control input-font cursor_pointer" bsDatepicker (bsValueChange)="bindStartDate($event)"
        [bsConfig]="{ dateInputFormat: 'MMM DD, YYYY' ,showWeekNumbers: false }" placeholder="Select Date"
        onkeypress="return false" show-weeks="false" (click)="datePicker()">

    <span class="date-button">
        <button type="button" class="calendar-btn">
            <img src="../../../../assets/images/calendar.svg" alt="calendar" class="calendar-icon">
        </button>
    </span>
</div>

    @if(form.get(field.name)?.invalid && form.get(field.name)?.touched){
    <small class="invalid-feedback">{{field.label}} is required</small>
    }
